(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  const COOLDOWN = 5000; /* ms before resuming autoplay */
  let timer;

  document.querySelectorAll('.vp-hero-slideshow slideshow-component').forEach((sc) => {
    const resumeAfterCooldown = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        sc.paused = false;
        sc.resume();
      }, COOLDOWN);
    };

    /* After drag ends — resume autoplay after cooldown */
    sc.addEventListener('pointerup', () => {
      if (sc.paused) resumeAfterCooldown();
    });

    /* After arrow / dot click — resume autoplay after cooldown */
    sc.addEventListener('click', (e) => {
      if (e.target.closest('slideshow-arrows, slideshow-controls')) {
        sc.suspend();
        resumeAfterCooldown();
      }
    });

    /* Infinite swipe: track touch/pointer direction, then loop at boundaries.
       Mobile uses touchstart/touchend (reliable on real devices).
       Desktop uses pointerdown/MutationObserver as fallback. */
    let swipeStartX = 0;
    let swipeStartIdx = null;

    /* — Mobile touch handling — */
    sc.addEventListener('touchstart', (e) => {
      swipeStartX = e.touches[0].clientX;
      swipeStartIdx = sc.current;
    }, { passive: true });

    sc.addEventListener('touchend', (e) => {
      if (swipeStartIdx === null) return;
      const dx = e.changedTouches[0].clientX - swipeStartX;
      const slides = sc.slides;
      if (!slides?.length || !sc.infinite) return;
      const last = slides.length - 1;
      const startIdx = swipeStartIdx;
      swipeStartIdx = null;
      /* Wait for drag handler to fully settle, then simulate arrow click
         to get the exact same animation path as chevron tap. */
      const prevBtn = sc.querySelector('slideshow-arrows .slideshow-control:first-of-type');
      const nextBtn = sc.querySelector('slideshow-arrows .slideshow-control:last-of-type');
      if (startIdx === last && dx < -30) {
        setTimeout(() => { if (sc.current !== 0 && nextBtn) nextBtn.click(); }, 50);
      } else if (startIdx === 0 && dx > 30) {
        setTimeout(() => { if (sc.current !== last && prevBtn) prevBtn.click(); }, 50);
      }
    }, { passive: true });

    /* — Desktop pointer/drag handling — */
    let dragStartX = 0;
    let pendingLoop = null;
    sc.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'touch') return; /* handled above */
      dragStartX = e.clientX;
      pendingLoop = null;
    });
    sc.addEventListener('pointerup', (e) => {
      if (e.pointerType === 'touch') return;
      const deltaX = e.clientX - dragStartX;
      const slides = sc.slides;
      if (!slides?.length || !sc.infinite) return;
      const last = slides.length - 1;
      const cur = sc.current;
      if (cur === last && deltaX < -20) pendingLoop = 'next';
      else if (cur === 0 && deltaX > 20) pendingLoop = 'prev';
      else pendingLoop = null;
    });
    const observer = new MutationObserver(() => {
      if (sc.hasAttribute('dragging') || !pendingLoop) return;
      const slides = sc.slides;
      if (!slides?.length) return;
      const last = slides.length - 1;
      const action = pendingLoop;
      pendingLoop = null;
      const prevBtn = sc.querySelector('slideshow-arrows .slideshow-control:first-of-type');
      const nextBtn = sc.querySelector('slideshow-arrows .slideshow-control:last-of-type');
      if (action === 'next' && sc.current === last && nextBtn) {
        nextBtn.click();
      } else if (action === 'prev' && sc.current === 0 && prevBtn) {
        prevBtn.click();
      }
    });
    observer.observe(sc, { attributes: true, attributeFilter: ['dragging'] });
  });

  } catch(e) { console.error(e); }
})();
})();
